import type { PickActions } from '@core/ngrx-legacy';
import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import type { PipelineTemplateListItem } from '@core/pipeline-templates-types';

export const offerScope = (id: number) => `offer:${id}`;
const idSelector = ({ id }: { id: number }) => id;
const { actions, reducer } = createEntityCollectionStore<PipelineTemplateListItem>()(
  'PipelineTemplateOfferListItem',
  {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchCollection: (state, payload: { offerId: number }) =>
          defaultActions.fetchCollection(state, { scope: offerScope(payload.offerId) }),
      };
    },
  },
);

const PipelineTemplateOfferListItemActions: PickActions<typeof actions, 'fetchCollection'> =
  actions;

export { PipelineTemplateOfferListItemActions, reducer as PipelineTemplateOfferListItemReducer };
